import { useParish } from "../lib/parishContext";
import { resolveApiUrl } from "../lib/url";

// Renders the parish identity in the header.
//
//   - Logo image when parishes.logo_url is set, served by the worker
//     at /api/parish/logo/:slug. Capped at 40px tall in the header.
//   - Inline display_name in serif type next to the logo (hidden on
//     very narrow viewports if the logo is present so the row stays
//     legible on phones).
//   - When no logo exists, display_name alone stands in for the logo.

interface ParishLogoProps {
  size?: number;
  showName?: boolean;
}

export default function ParishLogo({ size = 40, showName = true }: ParishLogoProps) {
  const { parish } = useParish();
  const logoSrc = resolveApiUrl(parish.logo_url);
  const hasLogo = Boolean(logoSrc);
  return (
    <div className="parish-logo" data-has-logo={hasLogo ? "true" : "false"}>
      {hasLogo ? (
        <img
          className="parish-logo__img"
          src={logoSrc}
          alt={`${parish.display_name} logo`}
          style={{ height: `${size}px` }}
        />
      ) : null}
      {showName ? (
        <span className="parish-logo__name">{parish.display_name}</span>
      ) : null}
    </div>
  );
}
